import React from "react"
import {
	Checkbox,
	FormControl,
	FormControlLabel,
	FormHelperText,
	ClassNameMap
} from "@mui/material"
import { Theme } from "@mui/material/styles";
import { withStyles } from "@mui/styles";
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import { Controller } from "react-hook-form";
import { getError } from "./fields";

interface ZPlayCheckboxProps {
	name: string,
	label: string,
	control: any,
	trigger: any,
	formState: any,
	disabled?: boolean,
	required?: boolean,
	onChange?: (data: boolean) => boolean,
	classes: ClassNameMap<"root">,
	icon?: React.ReactNode,
	checkedIcon?: React.ReactNode,
}

const styles = (theme: Theme) => ({
	root: {
		"& .MuiFormControlLabel-label": {
			color: "#FFFFFF",
		},
		"& .MuiFormControlLabel-label.Mui-disabled": {
			color: "#FFFFFF",
		},
		"& .MuiButtonBase-root": {
			color: "#FFFFFF",
		}
	}
});

class ZPlayCheckbox extends React.Component<ZPlayCheckboxProps, {}>
{
	static defaultProps = {
		required: false,
		icon: (<CheckBoxOutlineBlankIcon />),
		checkedIcon: (<CheckBoxIcon />),
	}

	render() {
		const { classes } = this.props;
		let error = getError(this.props.formState, this.props.name)

		return (
			<Controller
				name={this.props.name}
				control={this.props.control}
				render={({ field }) => (
					<FormControl
						component="fieldset"
						variant="standard"
						error={Boolean(error)}>
						<FormControlLabel
							control={
								<Checkbox
									checked={field.value}
									icon={this.props.icon}
									checkedIcon={this.props.checkedIcon}
									required={this.props.required}
									disabled={this.props.disabled || this.props.formState.isSubmitting}
									onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
										let value: boolean = event.target.checked
										const newValue = this.props.onChange?.(value) || value
										field.onChange(newValue)
										this.props.trigger(this.props.name)
									}}
								/>
							}
							className={classes.root}
							label={this.props.label} />
						<FormHelperText>{error?.message}</FormHelperText>
					</FormControl>
				)}
			/>
		)
	}
}

export default withStyles(styles)(ZPlayCheckbox);
